import { Point, Slot } from '@core/models/installation.model';
import moment from 'moment-timezone';
import { FALLBACK_TIME_ZONE } from './display-time.helper';

// A counter's `value` is its register reading and an interval's equals its quantity, so both plot
// `quantity`; only an average plots `value`. The gap comes from the chosen field being null and
// never from `quality`: a `partial` slot can still carry a number, and a `reset` or a first slot
// without a baseline carries none.
export function slotSeriesValue(point: Pick<Point, 'kind'>, slot: Slot): number | null {
  const chosen = point.kind === 'average' ? slot.value : slot.quantity;
  return chosen ?? null;
}

// The API serialises its SQL datetimes without an offset, and they are UTC: the device page reads
// `lastReadout` the same way. Parsed as a wall time in some zone instead, they shift by its offset.
export function utcIso(instant: string): string {
  return moment.utc(instant).toISOString();
}

export function zonedInstant(instant: string, timezone: string, format: string): string {
  return moment.utc(instant).tz(timezone).format(format);
}

// Every installation page shows its telemetry in the same zone: the one the response laid its
// slots out in, else the installation's own, else the zone the platform aggregates telemetry in.
export function installationZone(
  installationTimezone: string | null | undefined,
  telemetryTimezone?: string | null,
): string {
  return telemetryTimezone ?? installationTimezone ?? FALLBACK_TIME_ZONE;
}

export function browserZone(): string {
  return moment.tz.guess();
}
